<script>
    import parens from "../parens.vue";
    import { getMetadata } from "Formula/metadata";

    export default {
        components: { parens },
        inject: ["formulaControl"],
        provide() {
            // every expression provides itself. That creates nested provide/inject context.
            // When a component injects expressionControl, it will always get the nearest hierachical context.
            // In this case, this is exactly what we want, since every parens component will have injected
            // access to the expression that rendered it.
            return {
                expressionControl: this
            };
        },
        props: {
            expression: { type: Object, required: true },
            skipRegister: { type: Boolean, required: false, default: false },
            // Path provides the index list to reach the expression from editor and following it's children
            // For toolbox and view formulas it is []
            path: {
                type: Array,
                required: false,
                default: function () {
                    return [];
                }
            }
        },
        data() {
            return {
                operatorClassName: "operator",
                textOperatorClassName: "text-operator",
                wrap: false,
                childComponents: [],
                isRoot: false,
                extendsFromBaseExpression: true,
                alwaysShowParens: false
            };
        },
        computed: {
            children() {
                return this.expression.Children || [];
            },
            metadata() {
                return getMetadata(this.expression) || null;
            }
        },
        mounted() {
            if (this.skipRegister) {
                return;
            }
            this.formulaControl.registerExpression(this);
            // figure out the closest parent that extends from baseExpression
            let parent = this.$parent;
            while (parent && !parent.extendsFromBaseExpression) {
                parent = parent.$parent;
            }
            if (parent && parent.extendsFromBaseExpression && parent.registerChild) {
                parent.registerChild(this);
            }
            if (!parent) {
                this.isRoot = true;
            }
        },
        methods: {
            registerChild(child) {
                this.childComponents.push(child);
            },
            width() {
                return Math.ceil(this.$el.getBoundingClientRect().width);
            },
            wrapGain() {
                if (this.wrap) {
                    return 0;
                }
                if (this.wrapGainOverride) {
                    return this.wrapGainOverride();
                }
                if (this.childComponents.length <= 0) {
                    return 0;
                }
                return this.width() - Math.max(...this.childComponents.map((child) => child.width()));
            },
            getChildBinderByIndex(index) {
                const childBinder = {};
                childBinder.expression = (this.children && this.children[index]) || null;
                childBinder.operandType = (this.metadata && this.metadata.operandTypes[index]) || null;
                childBinder.path = [...this.path];
                childBinder.path.push(index);
                return childBinder;
            }
        }
    };
</script>
